import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

export default function QuickModal({ title, children, onClose }) {
  const ref = useRef(null);
  useEffect(() => {
    const previous = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    ref.current.focus();
    return () => { document.body.style.overflow = overflow; previous?.focus(); };
  }, []);
  const onKeyDown = (event) => {
    if (event.key === 'Escape') { event.stopPropagation(); onClose(); }
    if (event.key !== 'Tab') return;
    const controls = ref.current.querySelectorAll('button, a[href], input, select, textarea, [tabindex="0"]');
    const first = controls[0]; const last = controls[controls.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === ref.current)) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || document.activeElement === ref.current)) { event.preventDefault(); first?.focus(); }
  };
  return createPortal(
    <div className="modal show" style={{ display: 'block', background: 'rgba(0,0,0,.4)' }} onKeyDown={onKeyDown} onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div ref={ref} tabIndex={-1} className="modal-content" role="dialog" aria-modal="true" aria-label={title}>
          <div className="modal-header"><h5 className="modal-title">{title}</h5><button type="button" className="btn-close" aria-label="Cerrar" onClick={onClose} /></div>
          <div className="modal-body">{children}</div>
          <div className="modal-footer"><button type="button" className="btn btn-secondary" onClick={onClose}>Cerrar</button></div>
        </div>
      </div>
    </div>, document.body
  );
}
